module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-+.a2048945.svg";